// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3m9Kg","header":"PatientBlock_header__3YG3R","label":"PatientBlock_label__1FOdh","option":"PatientBlock_option__2jRqS"};